import { render, staticRenderFns } from "./OrderConfirmation.vue?vue&type=template&id=63c68252&lang=pug"
import script from "./OrderConfirmation.vue?vue&type=script&lang=js"
export * from "./OrderConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports